import React, { useState } from "react";
import { useWatchState } from "@/store";
import { checkResult } from "@/common";
import { BaseService, RemindService } from "@/service";
import moment from "moment";
import { Modal, Button, Form, Input, message, Divider } from "antd";

const { TextArea } = Input;
const TABLE_NAME = "editor";

const App = (props) => {

    const [loading, setLoading] = useState(false);
    const [[{ title, show, hide, width = 800, course = {} }]] = useWatchState(["modal." + TABLE_NAME])
    const { name, mainTeacher, orgName, profile, cover } = course;

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <section className="flex between">
                <div>
                    <p className="font-size-24 bold m-sm-b dark-primary">{name}</p>
                    <p className="font-size-14 dark-second">主讲：{mainTeacher}</p>
                    <p className="font-size-14 dark-second">单位：{orgName}</p>
                    <p className="font-size-14 dark-second">简介：{profile}</p>
                </div>
                <img src={cover} style={{ height: "150px" }} alt="" />
            </section>

            <Divider />

            <p>谢谢您的申请，本课程是石家庄科委付费课程，只对石家庄指定学员开放，如果您需要参与本课堂学习，请按下面两种方式申请。</p>

            <div className="flex child-full child-left-xl">
                <div>
                    <p>方式一：委托天合替您申请。请在下面留下您的留言。</p>
                    <p>A、给石家庄科委的理由。</p>
                    <Input />
                    <p>B、您的联系方式。</p>
                    <Input />
                </div>
                <div>
                    <p>方式二：您直接向石家庄科委申请。石家庄科委联系方式</p>
                    <p className="flex between">
                        <span>电话:</span>
                        <span>联系人:</span>
                    </p>
                    <p>地址：</p>
                </div>
            </div>

            <div className="flex hor child-left-xl m-md-t">
                <Button>提交</Button>
                <Button onClick={hide}>取消</Button>
            </div>
        </Modal>
    );
}

export default App;